module.exports = __webpack_public_path__ + "vue_assets/img/img_preorder_standalone_with_premium.2917ea7b.png";